import type { Translation } from 'Store'

export enum ZoneTabTypes {
  DETAILS = 'details'
}

export interface Zone {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  zone_id: string
  codespace_id: string
  translations: Translation[]
}

export interface FetchZoneListParams {
  bypass_pagination?: boolean
  sort_by?: string
  sort_order?: string
  start_index?: string
  count?: number
}

export interface FetchZoneListParams {
  bypass_pagination?: boolean
}
